export default "__VITE_ASSET__01f649b0__"